/**
 * @fileoverview gRPC-Web generated client stub for acompanha.orders.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/orders/v1/orders.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.orders = {};
proto.acompanha.orders.v1 = require('./orders_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.orders.v1.OrdersServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.orders.v1.OrdersServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.orders.v1.ListOrdersRequest,
 *   !proto.acompanha.orders.v1.ListOrdersResponse>}
 */
const methodDescriptor_OrdersService_ListOrders = new grpc.web.MethodDescriptor(
  '/acompanha.orders.v1.OrdersService/ListOrders',
  grpc.web.MethodType.UNARY,
  proto.acompanha.orders.v1.ListOrdersRequest,
  proto.acompanha.orders.v1.ListOrdersResponse,
  /**
   * @param {!proto.acompanha.orders.v1.ListOrdersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.orders.v1.ListOrdersResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.orders.v1.ListOrdersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.orders.v1.ListOrdersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.orders.v1.ListOrdersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.orders.v1.OrdersServiceClient.prototype.listOrders =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/ListOrders',
      request,
      metadata || {},
      methodDescriptor_OrdersService_ListOrders,
      callback);
};


/**
 * @param {!proto.acompanha.orders.v1.ListOrdersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.orders.v1.ListOrdersResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.orders.v1.OrdersServicePromiseClient.prototype.listOrders =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/ListOrders',
      request,
      metadata || {},
      methodDescriptor_OrdersService_ListOrders);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.orders.v1.GetOrdersSummaryRequest,
 *   !proto.acompanha.orders.v1.GetOrdersSummaryResponse>}
 */
const methodDescriptor_OrdersService_GetOrdersSummary = new grpc.web.MethodDescriptor(
  '/acompanha.orders.v1.OrdersService/GetOrdersSummary',
  grpc.web.MethodType.UNARY,
  proto.acompanha.orders.v1.GetOrdersSummaryRequest,
  proto.acompanha.orders.v1.GetOrdersSummaryResponse,
  /**
   * @param {!proto.acompanha.orders.v1.GetOrdersSummaryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.orders.v1.GetOrdersSummaryResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.orders.v1.GetOrdersSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.orders.v1.GetOrdersSummaryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.orders.v1.GetOrdersSummaryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.orders.v1.OrdersServiceClient.prototype.getOrdersSummary =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/GetOrdersSummary',
      request,
      metadata || {},
      methodDescriptor_OrdersService_GetOrdersSummary,
      callback);
};


/**
 * @param {!proto.acompanha.orders.v1.GetOrdersSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.orders.v1.GetOrdersSummaryResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.orders.v1.OrdersServicePromiseClient.prototype.getOrdersSummary =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/GetOrdersSummary',
      request,
      metadata || {},
      methodDescriptor_OrdersService_GetOrdersSummary);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.orders.v1.GetOrderRequest,
 *   !proto.acompanha.orders.v1.GetOrderResponse>}
 */
const methodDescriptor_OrdersService_GetOrder = new grpc.web.MethodDescriptor(
  '/acompanha.orders.v1.OrdersService/GetOrder',
  grpc.web.MethodType.UNARY,
  proto.acompanha.orders.v1.GetOrderRequest,
  proto.acompanha.orders.v1.GetOrderResponse,
  /**
   * @param {!proto.acompanha.orders.v1.GetOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.orders.v1.GetOrderResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.orders.v1.GetOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.orders.v1.GetOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.orders.v1.GetOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.orders.v1.OrdersServiceClient.prototype.getOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/GetOrder',
      request,
      metadata || {},
      methodDescriptor_OrdersService_GetOrder,
      callback);
};


/**
 * @param {!proto.acompanha.orders.v1.GetOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.orders.v1.GetOrderResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.orders.v1.OrdersServicePromiseClient.prototype.getOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/GetOrder',
      request,
      metadata || {},
      methodDescriptor_OrdersService_GetOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.orders.v1.DeleteOrderRequest,
 *   !proto.acompanha.common.v1.SuccessResponse>}
 */
const methodDescriptor_OrdersService_DeleteOrder = new grpc.web.MethodDescriptor(
  '/acompanha.orders.v1.OrdersService/DeleteOrder',
  grpc.web.MethodType.UNARY,
  proto.acompanha.orders.v1.DeleteOrderRequest,
  acompanha_common_v1_common_pb.SuccessResponse,
  /**
   * @param {!proto.acompanha.orders.v1.DeleteOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.SuccessResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.orders.v1.DeleteOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.SuccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.SuccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.orders.v1.OrdersServiceClient.prototype.deleteOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/DeleteOrder',
      request,
      metadata || {},
      methodDescriptor_OrdersService_DeleteOrder,
      callback);
};


/**
 * @param {!proto.acompanha.orders.v1.DeleteOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.SuccessResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.orders.v1.OrdersServicePromiseClient.prototype.deleteOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/DeleteOrder',
      request,
      metadata || {},
      methodDescriptor_OrdersService_DeleteOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.orders.v1.GetOrderTransactionRequest,
 *   !proto.acompanha.orders.v1.GetOrderTransactionResponse>}
 */
const methodDescriptor_OrdersService_GetOrderTransaction = new grpc.web.MethodDescriptor(
  '/acompanha.orders.v1.OrdersService/GetOrderTransaction',
  grpc.web.MethodType.UNARY,
  proto.acompanha.orders.v1.GetOrderTransactionRequest,
  proto.acompanha.orders.v1.GetOrderTransactionResponse,
  /**
   * @param {!proto.acompanha.orders.v1.GetOrderTransactionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.orders.v1.GetOrderTransactionResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.orders.v1.GetOrderTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.orders.v1.GetOrderTransactionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.orders.v1.GetOrderTransactionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.orders.v1.OrdersServiceClient.prototype.getOrderTransaction =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/GetOrderTransaction',
      request,
      metadata || {},
      methodDescriptor_OrdersService_GetOrderTransaction,
      callback);
};


/**
 * @param {!proto.acompanha.orders.v1.GetOrderTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.orders.v1.GetOrderTransactionResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.orders.v1.OrdersServicePromiseClient.prototype.getOrderTransaction =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/GetOrderTransaction',
      request,
      metadata || {},
      methodDescriptor_OrdersService_GetOrderTransaction);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.orders.v1.PayOrderRequest,
 *   !proto.acompanha.common.v1.SuccessResponse>}
 */
const methodDescriptor_OrdersService_PayOrder = new grpc.web.MethodDescriptor(
  '/acompanha.orders.v1.OrdersService/PayOrder',
  grpc.web.MethodType.UNARY,
  proto.acompanha.orders.v1.PayOrderRequest,
  acompanha_common_v1_common_pb.SuccessResponse,
  /**
   * @param {!proto.acompanha.orders.v1.PayOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.SuccessResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.orders.v1.PayOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.SuccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.SuccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.orders.v1.OrdersServiceClient.prototype.payOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/PayOrder',
      request,
      metadata || {},
      methodDescriptor_OrdersService_PayOrder,
      callback);
};


/**
 * @param {!proto.acompanha.orders.v1.PayOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.SuccessResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.orders.v1.OrdersServicePromiseClient.prototype.payOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/PayOrder',
      request,
      metadata || {},
      methodDescriptor_OrdersService_PayOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.orders.v1.UpdateOrderCommissionRequest,
 *   !proto.acompanha.orders.v1.GetOrderResponse>}
 */
const methodDescriptor_OrdersService_UpdateOrderCommission = new grpc.web.MethodDescriptor(
  '/acompanha.orders.v1.OrdersService/UpdateOrderCommission',
  grpc.web.MethodType.UNARY,
  proto.acompanha.orders.v1.UpdateOrderCommissionRequest,
  proto.acompanha.orders.v1.GetOrderResponse,
  /**
   * @param {!proto.acompanha.orders.v1.UpdateOrderCommissionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.orders.v1.GetOrderResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.orders.v1.UpdateOrderCommissionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.orders.v1.GetOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.orders.v1.GetOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.orders.v1.OrdersServiceClient.prototype.updateOrderCommission =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/UpdateOrderCommission',
      request,
      metadata || {},
      methodDescriptor_OrdersService_UpdateOrderCommission,
      callback);
};


/**
 * @param {!proto.acompanha.orders.v1.UpdateOrderCommissionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.orders.v1.GetOrderResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.orders.v1.OrdersServicePromiseClient.prototype.updateOrderCommission =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/UpdateOrderCommission',
      request,
      metadata || {},
      methodDescriptor_OrdersService_UpdateOrderCommission);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.orders.v1.UpdateOrderStagesRequest,
 *   !proto.acompanha.orders.v1.GetOrderResponse>}
 */
const methodDescriptor_OrdersService_UpdateOrderStages = new grpc.web.MethodDescriptor(
  '/acompanha.orders.v1.OrdersService/UpdateOrderStages',
  grpc.web.MethodType.UNARY,
  proto.acompanha.orders.v1.UpdateOrderStagesRequest,
  proto.acompanha.orders.v1.GetOrderResponse,
  /**
   * @param {!proto.acompanha.orders.v1.UpdateOrderStagesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.orders.v1.GetOrderResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.orders.v1.UpdateOrderStagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.orders.v1.GetOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.orders.v1.GetOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.orders.v1.OrdersServiceClient.prototype.updateOrderStages =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/UpdateOrderStages',
      request,
      metadata || {},
      methodDescriptor_OrdersService_UpdateOrderStages,
      callback);
};


/**
 * @param {!proto.acompanha.orders.v1.UpdateOrderStagesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.orders.v1.GetOrderResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.orders.v1.OrdersServicePromiseClient.prototype.updateOrderStages =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.orders.v1.OrdersService/UpdateOrderStages',
      request,
      metadata || {},
      methodDescriptor_OrdersService_UpdateOrderStages);
};


module.exports = proto.acompanha.orders.v1;

